import { Close } from '@mui/icons-material';
import { Grid, Card, Divider, Modal, Slide, Typography } from '@mui/material';
import React from 'react';
import { useState } from 'react';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import Gene20Button from '../../../Components/Gene20Button';
import Gene20Typography from '../../../Components/Gene20Typography';

export default function ClothesAndJewellery({ item, index }) {
  const [show, setShow] = useState(false);
  const toggleModal = () => setShow(!show);
  const MotiModal = (
    <Grid container>
      <Grid item xs={4}>
        <Modal
          key={index}
          open={show}
          onClose={toggleModal}
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0,0,0,0.2)',
          }}
        >
          <Slide direction="left" in={show} timeout={500}>
            <Gene20Box
              position="relative"
              width="500px"
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              sx={{
                backgroundColor: 'blue',
                margin: '2vh',
                color: 'aqua',
              }}
              shadow="xl"
            >
              <Gene20Box display="flex" alginItems="center" justifyContent="space-between">
                <Close fontSize="medium" sx={{ cursor: 'pointer' }} onClick={toggleModal} />
                <Gene20Box sx={{ display: 'block', width: '100%' }}>
                  <Gene20Typography
                    variant="h5"
                    sx={{
                      fontVariant: 'all-small-caps',
                      display: 'flex',
                    }}
                  >
                    {item.name}
                  </Gene20Typography>
                  <Card
                    component="img"
                    sx={{ overflow: 'hidden', width: '50%', mb: '1rem' }}
                    height="200px"
                    key={index}
                    src={item.image}
                  />
                </Gene20Box>
              </Gene20Box>
              <Divider sx={{ my: 0 }} />
              <Gene20Box p={2}>
                <Gene20Typography variant="body2" color="secondary" fontWeight="regular">
                  Society has put up so many boundaries, so many limitations on what&apos;s right
                  and wrong that it&apos;s almost impossible to get a pure thought out.
                  <br />
                  <br />
                  It&apos;s like a little kid, a little boy, looking at colors, and no one told him
                  what colors are good, before somebody tells you you shouldn&apos;t like pink
                  because that&apos;s for girls, or you&apos;d instantly become a gay two-year-old.
                </Gene20Typography>
              </Gene20Box>
              <Divider sx={{ my: 0 }} />
              <Gene20Box display="flex" justifyContent="space-between" p={1.5}>
                <Gene20Button variant="gradient" color="dark" onClick={toggleModal}>
                  close
                </Gene20Button>
                <Gene20Button variant="contained">order</Gene20Button>
              </Gene20Box>
            </Gene20Box>
          </Slide>
        </Modal>
      </Grid>
    </Grid>
  );

  return (
    <Gene20Box
      sx={{
        margin: { sm: '1rem' },
        borderRadius: '30px',
        overflow: 'hidden',
        backgroundColor: 'rgba(0,0,0,0.5)',
      }}
    >
      <Gene20Box sx={{ backgroundColor: 'rgba(0,0,0,0.2)', p: '0.5rem' }}>
        <Typography variant="h4" color="secondary" align="center">
          {item.shopName}
        </Typography>
      </Gene20Box>

      <Gene20Box sx={{ display: 'flex', padding: '1rem' }}>
        <Card
          component="img"
          sx={{ overflow: 'hidden', mb: '1rem', width: 200, height: 200 }}
          src={item.image}
        />
        <Gene20Box sx={{ padding: { sm: '1rem' } }}>
          <Gene20Typography variant="h6">
            <strong>product</strong>&nbsp;:&nbsp;{item.name}
          </Gene20Typography>
          <Gene20Typography variant="h6">
            <strong>price</strong>&nbsp;:&nbsp;{item.price}
          </Gene20Typography>
          <Gene20Typography variant="h6">
            <strong>shop</strong>&nbsp;:&nbsp;{item.shopName}
          </Gene20Typography>
        </Gene20Box>
      </Gene20Box>

      <Gene20Box sx={{ display: { sm: 'flex' }, padding: '1rem' }}>
        <Gene20Button
          variant="contained"
          onClick={toggleModal}
          sx={{ width: 150, m: '0.5rem' }}
          color="dark"
        >
          order
        </Gene20Button>
        <Gene20Button sx={{ width: 200, m: '0.5rem' }} variant="contained" color="primary">
          visit shop
        </Gene20Button>
      </Gene20Box>
      <Gene20Box>{MotiModal}</Gene20Box>
    </Gene20Box>
  );
}
